export const DEFAULT_BACKGROUND_DATA = {
  x: {
    Twitter: -196.66,
    Facebook: -182.64,
    InstagramStories: -710.5,
    InstagramPost: -100,
    LinkedIn: -159.51,
    YouTubeCommunity: -487.17,
    BlogFeatured: -252.09,
    BlogSocialShare: -279.38,
    BlogSocialShareInternal: 0,
    LandingPage: 0,
    Email01: -200,
  },
  y: {
    Twitter: -670.82,
    Facebook: -659.22,
    InstagramStories: -337.59,
    InstagramPost: -1625,
    LinkedIn: -683.16,
    YouTubeCommunity: -619.19,
    BlogFeatured: -1236.42,
    BlogSocialShare: -1256.52,
    BlogSocialShareInternal: 0,
    LandingPage: 0,
    Partners: 0,
    Email01: -1625,
  },
  scale: {
    Twitter: 0.882,
    Facebook: 0.868,
    InstagramStories: 1.181,
    InstagramPost: 1,
    LinkedIn: 0.871,
    YouTubeCommunity: 1,
    BlogFeatured: 1.729,
    BlogSocialShare: 1.764,
    BlogSocialShareInternal: 1,
    LandingPage: 1,
    Partners: 1,
    Email01: 1,
  },
};